import { notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useState, useEffect } from 'react';
import { updateRoom } from 'services/api';
import type { Room, UpdateRoomBody } from 'services/api';
import type { RoomFormValues } from '../../types';

interface UseEditServiceProps {
  hide: () => void;
  onItemEdit: () => void;
  buildingId: number;
  selectedRoom: Room | null;
}

export const useEditService = ({
  hide,
  onItemEdit,
  buildingId,
  selectedRoom,
}: UseEditServiceProps) => {
  const [form] = useForm<RoomFormValues>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedRoom) {
      form.setFieldsValue({
        ...selectedRoom,
        subjectsIds: selectedRoom.subjects?.map((subject) => subject.id),
      });
    }
  }, [selectedRoom]);

  const onSubmit = () => {
    form.validateFields().then(({ number, name, subjectsIds }) => {
      const body: UpdateRoomBody = {
        number,
        name,
        buildingId,
        subjectsIds,
      };
      updateRoom(selectedRoom!.id, body)
        .then(() => {
          hideModal();
          onItemEdit();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось обновить аудиторию' });
          throw error;
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  return {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  };
};
